import { walttiBrightVioletActive } from 'Util/colors'
import { colors, useTheme } from '@mui/material'
import { PickersDay, type PickersDayProps } from '@mui/x-date-pickers'

export default function SchoolCalendarDay(
  props: PickersDayProps<Date> & { isDisabled?: boolean; isSelected?: boolean; monthIndex?: number }
) {
  const theme = useTheme()
  const { day, isDisabled, isSelected, monthIndex = 0, ...other } = props
  const dayOfWeek = day.getDay()
  const isSaturday = dayOfWeek === 6
  const isSunday = dayOfWeek === 0
  let calendarDayStyle = {}

  if (isSelected) {
    calendarDayStyle = {
      backgroundColor: walttiBrightVioletActive,
      color: '#fff',
      '&:focus': {
        backgroundColor: walttiBrightVioletActive
      }
    }
  } else if (isSaturday) {
    calendarDayStyle = {
      backgroundColor: colors.yellow[100],
      color: theme.palette.mode === 'dark' ? 'black' : theme.palette.text.primary,
      '&:focus': {
        backgroundColor: colors.yellow[100]
      }
    }
  } else if (isSunday) {
    calendarDayStyle = {
      backgroundColor: colors.red[100],
      color: theme.palette.mode === 'dark' ? 'black' : theme.palette.text.primary,
      '&:focus': {
        backgroundColor: colors.red[100]
      }
    }
  }

  return (
    <PickersDay
      {...other}
      day={day}
      sx={{
        ...other.sx,
        ...calendarDayStyle,
        '&:hover': {
          backgroundColor: theme.palette.secondary.main
        }
      }}
    />
  )
}
